import http from '../../utils/http';
const rootUrl = '/api';
const dentalxUrl = '/dentalx/api';

const serviceTerms = {
	/**
	 * 检查用户是否需要同意最新版本合规配置
	 * @returns
	 */
	checkComplianceVersion(params) {
		return http.get( `${dentalxUrl}/dentalxCheckComplianceVersion`, params, { errCode: '@shining3d/xl-design-order.apiErr.serviceTerms' });
	},
	/**
	 * 更新用户同意的合规版本
	 * @returns
	 */
	updateComplianceVersion(data) {
		return http.post( `${dentalxUrl}/dentalxUpdateComplianceVersion`, data, { errCode: '@shining3d/xl-design-order.apiErr.serviceTerms' });
	},
    getInfo() {
		return http.get( `${rootUrl}/getUserProfile`, { errCode: '@shining3d/info-component.infoComponent.apiErr.info.getInfo' });
	},
};
export default serviceTerms;
